import React from 'react';
import { ClipboardCheckIcon, SparklesIcon } from 'lucide-react';
const oldWayFeatures = ["Optimizing only for Google's blue links", 'No visibility into AI-generated answers', 'Reactive content strategy', 'Limited competitive intelligence', 'Missing the AI search revolution'];
const newWayFeatures = ['Optimized for ChatGPT, Perplexity, Google AI Overviews', 'Real-time AI search visibility tracking', 'Proactive, data-driven content strategy', 'Deep competitive intelligence across AI engines', 'First-mover advantage in AI search'];
const FeatureSection = () => {
  return <div id="platform" className="py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="lg:text-center" data-id="element-83">
          <h2 className="text-sm text-accent font-bold tracking-widest uppercase" data-id="element-84">
            Why AEO/GEO
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-customblack sm:text-4xl" data-id="element-85">
            Traditional SEO alone isn't enough anymore
          </p>
          <p className="mt-4 max-w-2xl text-xl text-customgray lg:mx-auto" data-id="element-86">
            AI search engines are changing how customers discover brands.
            Steward helps you adapt and thrive in the generative internet.
          </p>
        </div>

        <div className="mt-16" data-id="element-87">
          <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10" data-id="element-88">
            {/* Traditional SEO Card */}
            <div className="relative bg-white p-8 rounded-2xl shadow-sm border border-gray-200 transition-shadow hover:shadow-md" data-id="element-89">
              <dt data-id="element-90">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-xl bg-slate-700 text-white shadow-sm" data-id="element-91">
                  <ClipboardCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-92" />
                </div>
                <p className="ml-16 text-xl leading-6 font-bold text-customblack mt-3" data-id="element-93">
                  Traditional SEO
                </p>
              </dt>
              <dd className="mt-8 ml-0 sm:ml-16" data-id="element-94">
                <ul className="space-y-4" data-id="element-95">
                  {oldWayFeatures.map((feature, index) => <li key={index} className="flex items-start text-customgray" data-id="element-96">
                      <span className="h-2 w-2 bg-slate-400 rounded-full mr-3 mt-2 flex-shrink-0" data-id="element-97"></span>
                      <span className="text-base" data-id="element-98">{feature}</span>
                    </li>)}
                </ul>
              </dd>
            </div>

            {/* AEO/GEO Card */}
            <div className="relative bg-white p-8 rounded-2xl shadow-xl border border-accent/20 ring-1 ring-accent/10 transition-shadow hover:shadow-2xl" data-id="element-99">
              <dt data-id="element-100">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-xl bg-accent text-white shadow-md shadow-accent/30" data-id="element-101">
                  <SparklesIcon className="h-6 w-6" aria-hidden="true" data-id="element-102" />
                </div>
                <p className="ml-16 text-xl leading-6 font-bold text-customblack mt-3" data-id="element-103">
                  AEO/GEO with Steward
                </p>
              </dt>
              <dd className="mt-8 ml-0 sm:ml-16" data-id="element-104">
                <ul className="space-y-4" data-id="element-105">
                  {newWayFeatures.map((feature, index) => <li key={index} className="flex items-start text-customgray font-medium" data-id="element-106">
                      <span className="h-2 w-2 bg-accent rounded-full mr-3 mt-2 flex-shrink-0 shadow-sm shadow-accent/50" data-id="element-107"></span>
                      <span className="text-base" data-id="element-108">{feature}</span>
                    </li>)}
                </ul>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>;
};
export default FeatureSection;